import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CustomerRegistrationSuccessComponent } from '@app/auth/customer-registration/customer-registration-success/customer-registration-success.component';
import { CustomerRegistrationSmartComponent } from '@app/auth/customer-registration/customer-registration.smart.component';
import { LoginRequiredComponent } from '@app/auth/login-required/login-required.component';
import { SharedModule } from '@app/shared/shared.module';
import { RegistrationFormSmartComponent } from './customer-registration/registration-form/registration-form.smart.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    RegistrationFormSmartComponent,
    CustomerRegistrationSmartComponent
  ],
  declarations: [
    LoginRequiredComponent,
    CustomerRegistrationSuccessComponent
  ]
})
export class AuthModule { }
